export const LTG = 1
export const TRAINING = 2
